import type { UseQueryOptions } from '@core/types'
import type { components as StrapiComponents } from '@core/types/clients/strapi'
import { useCoreConfig, useQuery, useStrapi } from '#imports'

export const useStrapiWinnersSidebar = () => {
    const { site } = useCoreConfig()
    const strapi = useStrapi()

    function getWinnersSidebarByKey(
        options: Pick<UseQueryOptions<any>, 'enabled' | 'lazy' | 'server'> = {},
        key: string
    ) {
        const { enabled = true, lazy = false, server = false } = options
        const query = useQuery<StrapiComponents['schemas']['WinnersSidebar']>(async () => {
            const { data } = await strapi.GET('/winners-sidebar/{key}', {
                params: {
                    path: { key },
                    query: { brand: site.brand }
                },
            })
            return data
        }, {
            key: key,
            lazy,
            server,
            enabled,
        })
        return query
    }

    return {
        getWinnersSidebarByKey
    }
}
